import css1 from '../img/portImages/cv_css.png';
import css2 from '../img/portImages/ms.png';
import react1 from '../img/portImages/react_styled.png';
import img2 from '../img/portImages/maya-4.jpg';
import img3 from '../img/portImages/maya-3.jpg';
import eperda from '../img/portImages/eperda.png';
import LMS from '../img/portImages/LMS.png';
import gkpd from '../img/portImages/gkpd.png';
import sppirt from '../img/portImages/sppirt.png';


const portfolios = [
    {
        id: 1,
        category: ['Codeigniter', 'Jquery'],
        image: gkpd,
        link1: 'https://gkpd.pom.go.id/index.php',
        title: 'Sistem GKPD BPOM',
        text: 'Sistem Gerakan Keamanan Pangan Desa BPOM RI'
    },
    {
        id: 2,
        category: ['Codeigniter', 'Jquery'],
        image: sppirt,
        link1: 'https://sppirt.pom.go.id/Home',
        title: 'Sistem SPPIRT Badan POM RI',
    },
    {
        id: 2,
        category: ['Codeigniter', 'Jquery'],
        image: eperda,
        link1: 'http://eperda.kemendagri.go.id/',
        title: 'Sistem e-Perda Kemendagri',
        text : "ePerda merupakan aplikasi yang bertujuan untuk mempercepat proses fasilitasi dari Rancangan Peraturan Daerah. Melalui aplikasi ePerda ini, diharapkan dapat lebih meningkatkan efektifitas dan efisiensi kerja, karena segala prosesnya berbasis digital."
    },
    {
        id: 3,
        category: ['React', 'Express.js'],
        image: LMS,
        link1: 'https://dev-lms2022.netlify.app/',
        title: 'Learning Management System',
        text : "Learning Management System (LMS) merupakan sistem yang dapat mengatur kegiatan belajar mengajar, mengatur kegiatan pembelajaran, mengatur kegiatan penilaian, mengatur kegiatan pengumpulan hasil belajar, dan mengatur kegiatan pengiriman hasil belajar kepada pihak luar. Project ini diperuntukan di negara Belanda"
    },
];

export default portfolios;
